import { useState, useCallback, useEffect } from 'react'
import { useAuthStore } from '../stores/authStore'
import { useOnboardingStore } from '../stores/onboardingStore'
import { getStepsForRole } from '../lib/onboardingSteps'

export function useOnboarding() {
  const { user } = useAuthStore()
  const { progress, loadProgress, markTourStarted, markTourCompleted, markTourOptedOut } = useOnboardingStore()
  const [run, setRun] = useState(false)
  const [stepIndex, setStepIndex] = useState(0)

  // Cargar progreso al montar
  useEffect(() => {
    if (user) {
      loadProgress()
    }
  }, [user, loadProgress])

  const steps = user ? getStepsForRole(user.role) : []

  // El tour está completado si el backend lo dice o si el usuario optó por no hacerlo
  const completed = progress?.tourCompleted || progress?.tourOptedOut || false

  const handleStartTour = useCallback(() => {
    setStepIndex(0)
    setRun(true)
    markTourStarted()
  }, [markTourStarted])

  const handleMarkCompleted = useCallback(() => {
    markTourCompleted()
    setRun(false)
    setStepIndex(0)
  }, [markTourCompleted])

  const handleOptOut = useCallback(() => {
    markTourOptedOut()
    setRun(false)
  }, [markTourOptedOut])

  const handlePause = useCallback((_currentStep: number) => {
    setRun(false)
    // Guardar el último step visto
    // Nota: no tenemos un campo específico para esto en el backend,
    // pero podríamos añadirlo si es necesario
  }, [])

  const restart = useCallback(() => {
    setStepIndex(0)
    setRun(true)
    markTourStarted()
  }, [markTourStarted])

  return {
    steps,
    run,
    stepIndex,
    setStepIndex,
    setRun,
    completed,
    handleStartTour,
    handleMarkCompleted,
    handleOptOut,
    handlePause,
    restart,
  }
}
